import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { InsuredNotification } from "../model/insuredNotification";
import { InsuredNotificationDetail } from "../model/insuredNotificationDetail";
import { NotificationTypeEnum } from "../model/enums/NotificationTypeEnum";

@Injectable()
export class InsuredNotificationService {



    constructor(private http: GlobalService,
        private entityService: EntityService) { }

    /**
     * With a type, returns only that type; without one, returns all except PrecargaTerceroWeb.
     */
    search(type?: NotificationTypeEnum): Observable<InsuredNotification[]> {
        const url = type ? `notification?type=${type}` : `notification`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<InsuredNotification[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const notification = new InsuredNotification();
                    return this.entityService.copy(dataItem, notification);
                });
            });
    }


    count(type?: NotificationTypeEnum): Observable<number> {
        const url = type ? `notification/count?type=${type}` : `notification/count`;
        return this.http
            .get(url)
            .map(res => this.entityService.extractData<number>(res));
    }


    details(id: number): Observable<InsuredNotificationDetail[]> {
        const url = `notification/details/${id}`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<InsuredNotificationDetail[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const notification = new InsuredNotificationDetail();
                    return this.entityService.copy(dataItem, notification);
                });
            });
    }

    /**
     * POST /api/notifications
     * Marks notification as visualized
     */
    markAsVisualized(notificationId: number): Observable<void> {
        const url = `notification/update`;
        return this.http.post(url, notificationId).map((apiResponse: any) => { });
    }

    /**
     * Marks every detail of the notification as visualized
     */
    markAllAsVisualized(notificationId: number): Observable<void> {
        const url = `notification/markasread`;
        return this.http.post(url, notificationId).map((apiResponse: any) => { });
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/insuredNotificationService.ts